import { useAiAssistantAdminContext } from "./ai-assistant-admin-context";
import { CapMeterCard } from "./cap-meter-card";
import { TodaySummary } from "./today-summary";
import { useAssistantUsage } from "./use-assistant-usage";

/**
 * Sub menu "Pemakaian & Biaya": ringkasan hari ini, meteran plafon, rincian
 * model, dan tarif.
 *
 * Kartu "Log penggunaan penyedia" (`UsageLogCard`) DIPINDAH ke sub menu
 * "Log Percakapan" sebagai tab "Semua Giliran" (rancangan 08 §2) — halaman ini
 * sekarang hanya menjawab "berapa habisnya", bukan "siapa bertanya apa".
 */
export function PemakaianPage() {
	const { overview, disabled } = useAiAssistantAdminContext();
	const usage = useAssistantUsage(overview.settings);
	return (
		<>
			<TodaySummary today={overview.today} />
			<CapMeterCard usage={usage} disabled={disabled} />
		</>
	);
}
